interface IDetailServiceObservationProps {
  observation: string;
}

const DetailServiceObservation = (props: IDetailServiceObservationProps) => {
  return (
    <div className="mb-4">
      <div className="font-bold mb-2 text-size-12 text-gray-500">Observação</div>
      <div className="text-size-14 bg-white p-3 rounded border border-gray-200">
        {props.observation}
      </div>
    </div>
  );
};

export default DetailServiceObservation;

